{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/text-columns",
	"title": "Text Columns (deprecated)",
	"icon": "columns",
	"category": "design",
	"description": "This block is deprecated. Please use the Columns block instead.",
	"textdomain": "default",
	"attributes": {
		"content": {
			"type": "array",
			"source": "query",
			"selector": "p",
			"query": {
				"children": {
					"type": "string",
					"source": "html"
				}
			},
			"default": [ {}, {} ]
		},
		"columns": {
			"type": "number",
			"default": 2
		},
		"width": {
			"type": "string"
		}
	},
	"supports": {
		"inserter": false,
		"interactivity": {
			"clientNavigation": true
		}
	},
	"editorStyle": "wp-block-text-columns-editor",
	"style": "wp-block-text-columns"
}
